export const map = {
  map: {
    shape:
      '<path fill="#000" fill-opacity=".98" d="m20 27.067-8-2.8L6.733 26.3c-.356.133-.678.1-.967-.1-.289-.2-.433-.489-.433-.867v-16.3c0-.244.056-.461.167-.65a.983.983 0 0 1 .5-.416l6-2.034 8 2.8L25.266 6.7c.356-.133.678-.111.967.067.289.177.433.444.433.8v16.5c0 .244-.072.461-.217.65a1.274 1.274 0 0 1-.55.416L20 27.067Zm-.667-1.634v-15.6L12.666 7.5v15.6l6.667 2.333Zm1.333 0 4.667-1.533V8.1l-4.667 1.733v15.6Zm-14-.533 4.667-1.8V7.5L6.666 9.1v15.8Z"/>',
    viewBox: [0, 0, 32, 32],
  },
};
